import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { Group, Menu as BaseMenu } from '@calendly/ui/components/menu';
import { ControlUI } from '@calendly/ui/components/select';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef, useMemo } from 'react';
import { OptionsContainer, Option } from 'features/filter_menu';
export const PERMISSION_TRIGGER_TEST_ID = 'event-types-filter-permission-trigger';
export const PERMISSION_MENU_TEST_ID = 'event-types-filter-permission-menu';
export const permissionOptionTestId = id => `event-types-filter-permission-option-${id}`;
const wrapperCss = "w16fylik";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const containerCss = "cr31s2d";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const styledFixedContainerCss = "s15lrhbu";
const StyledFixedContainer = forwardRef((props, ref) => <FixedContainer ref={ref} {...props} className={classNames(styledFixedContainerCss, props.className)} />);
const menuCss = "m13ophn0";
const Menu = forwardRef((props, ref) => <BaseMenu ref={ref} {...props} className={classNames(menuCss, props.className)} />);
const optionWrapperCss = "o1u16cit";
const OptionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionWrapperCss, props.className)} />;
});
const SelectorWrapper = ({
  indent,
  children
}) => indent ? <Wrapper>{children}</Wrapper> : children;
const getPermissionOptions = () => [{
  id: 'editor',
  name: I18n.t('publisher.event_types.edit_hosts_modal.permissions.editor')
}, {
  id: 'viewer',
  name: I18n.t('publisher.event_types.edit_hosts_modal.permissions.viewer')
}];
export const PermissionSelector = ({
  value,
  onChange,
  indent
}) => {
  const [toggleDropdown, Dropdown, isOpen] = useDropdown();
  const label = I18n.t('publisher.event_types.filters.titles.permission');
  const options = useMemo(() => getPermissionOptions(), []);
  const selectedOption = options.find(option => option.id === value);
  const handleSelect = item => {
    onChange(value === item.id ? '' : item.id);
    toggleDropdown();
  };
  return <SelectorWrapper indent={indent}>
      <Container>
        <BodyText color="muted" weight="bold" inline>{label}</BodyText>
        <ControlUI expanded={isOpen} onClick={toggleDropdown} aria-label={label} data-testid={PERMISSION_TRIGGER_TEST_ID} aria-expanded={isOpen}>
          {selectedOption ? <BodyText>{selectedOption.name}</BodyText> : <BodyText color="muted">{I18n.t('publisher.event_types.filters.select_placeholder')}</BodyText>}
        </ControlUI>
        <Dropdown>
          <Menu data-component="filter-dropdown-menu" data-testid={PERMISSION_MENU_TEST_ID}>
            <Group>
              <OptionsContainer>
                {options.map(item => <OptionWrapper key={item.id} data-testid={permissionOptionTestId(item.id)}>
                    <Option item={item} onClick={handleSelect} selected={value === item.id} />
                  </OptionWrapper>)}
              </OptionsContainer>
            </Group>
          </Menu>
        </Dropdown>
        {isOpen && <StyledFixedContainer fixedWhen />}
      </Container>
    </SelectorWrapper>;
};

require("./permission_selector.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./permission_selector.js");